// @ts-nocheck
import React, { useState } from "react";
import { useLanguageContext } from "../context/languageContext";
import businessConfig from "../config/business";
import { formatUnit } from "../utils/price";
import MenuImage from "./MenuImage";

/**
 * Some dishes are illustrated with a stock photo rather than a photo of the plate
 * this kitchen sends out. Those are marked so the guest is not misled.
 */
const ReferenceImageBadge = ({ product }) => {
    const { t } = useLanguageContext();
    const [showTooltip, setShowTooltip] = useState(false);

    if (!product.isReferenceImage || !product.imageUrl) return null;

    return (
        <div className="absolute bottom-2 left-2 z-10">
            <button
                onClick={(e) => { e.stopPropagation(); setShowTooltip(!showTooltip); }}
                className="flex items-center gap-1.5 bg-black/70 backdrop-blur-md px-2 py-1 rounded-md border border-white/10"
            >
                <div className="w-1.5 h-1.5 rounded-full bg-white/60"></div>
                <span className="text-[9px] font-black uppercase tracking-wider text-white/80 italic">
                    {t("reference_image", "Reference")}
                </span>
            </button>
            {showTooltip && (
                <div className="absolute bottom-full mb-2 left-0 w-40 p-2 bg-white rounded-xl shadow-2xl border border-slate-100 text-[11px] font-medium text-slate-500 leading-tight">
                    {t("actual_product_may_vary", "Actual product may vary in appearance.")}
                </div>
            )}
        </div>
    );
};

const ProductDetailCard = ({ product }) => {
    const { language, t } = useLanguageContext();

    const getTranslatedName = () => {
        if (!product?.itemTranslation) return product.name;
        const translations = product.itemTranslation;
        const map = { en: 'englishName', it: 'italianName', sq: 'albanianName', de: 'germanName', es: 'spanishName', pl: 'polishName', ukr: 'ukrainianName' };
        return translations[map[language]] || product.name;
    };

    return (
        <div className="group flex flex-col bg-white rounded-2xl border border-slate-50 transition-all duration-300 hover:border-brand/10 hover:shadow-[0_15px_30px_-10px_rgba(0,0,0,0.05)] overflow-hidden h-full">
            <div className="relative w-full aspect-square bg-slate-50 overflow-hidden">
                <MenuImage
                    src={product.imageUrl}
                    alt={getTranslatedName()}
                    icon={product.icon}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />

                {/* Price Pill: Sharp Styled */}
                <div className="absolute top-2.5 left-2.5 px-2 py-1 bg-white/95 backdrop-blur-md border border-black/[0.03] rounded-lg shadow-sm">
                    <p className="text-xs font-black text-slate-900 tracking-tight">
                        {product.price} <span className="text-[9px] text-slate-400 uppercase">{businessConfig.currency}</span>
                    </p>
                    {product.priceUnit && (
                        <p className="text-[8px] font-black uppercase tracking-wider text-brand leading-none mt-0.5">
                            {formatUnit(t, product.priceUnit)}
                        </p>
                    )}
                </div>

                <ReferenceImageBadge product={product} />
            </div>

            <div className="p-3 flex flex-col flex-grow gap-1">
                <h2 className="text-sm font-bold text-slate-900 leading-snug">{getTranslatedName()}</h2>
                {product.description && (
                    <p className="text-[11px] font-medium text-slate-400 leading-tight">
                        {/* The printed menu marks its own with "Specialiteti i lokalit";
                            show that in the language the guest is reading. */}
                        {/specialitet/i.test(product.description)
                            ? t("houseSpecialityTag", product.description)
                            : product.description}
                    </p>
                )}
            </div>
        </div>
    );
};

export default ProductDetailCard;
